import { Box, Grid, InputAdornment, Skeleton } from '@mui/material';
import CardFrom, { CardFormConfig } from '../../component/card/card-from';
import { ProductState } from './product-state';
import ButtonComponent from '../../component/button/button.component';
import i18n from '../../i18n';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react-lite';
import { MobxObjectsManager, useManualRemove } from '../mobx-objs/mobx-manager';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import CardView from '../../component/card/card-view';
import { TopBarState } from '../../component/top-bar/top-bar-state';

// 卡片组渲染数据
export const productCardArr: CardFormConfig[] = [
    // 主要信息数据
    {
        key: 'main',
        title: i18n.t('product_list_page_product_detail'),
        rowSpacing: 6,
        xs: 12,
        md: 12,
        columnSpacing: { md: 1 },
        titleTypographyProps: {
            // height: 50
            paddingRight: 0
        },
        children: [
            {
                key: 'name_EN',
                label: `${i18n.t('global_text_name')} (EN)`,
                required: true,
                comType: 'INPUT',
                inputType: 'INPUT',
                xs: 6,
                md: 6,
            }, {
                key: 'name_IT',
                label: `${i18n.t('global_text_name')} (IT)`,
                comType: 'INPUT',
                inputType: 'INPUT',
                xs: 6,
                md: 6,
            }, {
                key: 'name_CN',
                label: `${i18n.t('global_text_name')} (CN)`,
                comType: 'INPUT',
                inputType: 'INPUT',
                xs: 6,
            }, {
                key: 'name_SP',
                label: `${i18n.t('global_text_name')} (SP)`,
                comType: 'INPUT',
                inputType: 'INPUT',
                xs: 6,
            }, {
                key: 'price',
                label: i18n.t('general_text_price'),
                required: true,
                comType: 'INPUT',
                contentType: 'number',
                regularType: 'price',
                inputType: 'INPUT',
                xs: 6,
                InputProps: {
                    endAdornment: <InputAdornment position='end'>€ / {i18n.t('warrant_page_text_one_year')}</InputAdornment>
                },
            }, {
                key: 'description_EN',
                label: `${i18n.t('restaurant_info_page_text_description')} (EN)`,
                comType: 'INPUT',
                inputType: 'INPUT',
                xs: 12,
            }, {
                key: 'description_IT',
                label: `${i18n.t('restaurant_info_page_text_description')} (IT)`,
                comType: 'INPUT',
                inputType: 'INPUT',
                xs: 12,
            }, {
                key: 'description_CN',
                label: `${i18n.t('restaurant_info_page_text_description')} (CN)`,
                comType: 'INPUT',
                inputType: 'INPUT',
                xs: 12,
            }, {
                key: 'description_SP',
                label: `${i18n.t('restaurant_info_page_text_description')} (SP)`,
                comType: 'INPUT',
                inputType: 'INPUT',
                xs: 12,
            },

        ]
    }

];



/**
 * 产品信息详情
 */
const Product = observer((props: ProductProps) => {
    useTranslation();

    const { componentType } = props;
    // 数据管理
    const useMobxData = props.useProductMobx;
    // 顶部栏数据
    const topBarState = MobxObjectsManager.get(TopBarState);

    // 骨架屏控制
    const [skeleton, setSkeleton] = React.useState<boolean>(true);


    React.useEffect(() => {
        initComponent();
        topBarState.updateProductionInfoTitle('');
        // 卸载
        return () => {
            // MobxObjectsManager.remove(ProductState);
        }
    }, []);

    // 初始化组件
    const initComponent = async () => {
        await useMobxData.init();
        // 关闭骨架屏
        setSkeleton(false);
    }
    // unmount
    useManualRemove(ProductState);

    // 数据
    const {
        productEditDetail,
        operateMap,
        isEditInput,
        isEmptyVerify,
        disabledBtn
    } = useMobxData;

    // 卡片组渲染数据
    const cardArr: CardFormConfig[] = productCardArr.map((parentItem) => {

        return {
            ...parentItem,
            children: parentItem?.children?.map((childrenItem) => {
                return {
                    ...childrenItem,
                    // 非空校验
                    isEmpty: isEmptyVerify,
                    // 编辑禁用
                    disabledInput: componentType === 'PREVIEW' ? true : isEditInput,
                    // 编辑反馈
                    inputIsEdited: operateMap.get(childrenItem.key) !== undefined ? true : false,
                    onChange: (e) => {
                        return useMobxData.handleChangeText(e.target.value, childrenItem.key);
                    }
                }
            })
        }
    }) as CardFormConfig[];

    // *********************
    // Business Function
    // *********************

    return <div className='reseller-management-page reseller-unit'>
        <Box className='FC' marginBottom={'1rem'} >
            <Box className='top-button-group'>
                <ButtonComponent
                    {...{
                        variant: 'contained',
                        size: 'small',
                        extraButtonStyle: 'return-button',
                        extraTitleStyle: 'return-button-icon',
                        titleText: `${i18n.t('general_button_go_back')}`,
                        // 返回集团管理列表
                        handleClick: () => { props.goBack(); },
                        children: <ChevronLeftIcon />
                    }}
                />
                <ButtonComponent
                    size='small'
                    variant={'contained'}
                    forbidConfirm={disabledBtn}
                    // extraButtonStyle={'button-group'}
                    extraTitleStyle={'button-icon'}
                    titleText={`${i18n.t('general_text_save')}`}
                    action={'SAVE'}
                    handleClick={async () => {
                        // 检查必填项
                        await useMobxData.onSave('EDIT');
                    }}
                />
            </Box>
        </Box>
        {
            skeleton ? (
                <SkeletonViewComp />
            ) : (
                <Box className={'contain'}>
                    {/* 卡片grid布局视图 */}
                    <CardFrom
                        config={cardArr}
                        data={productEditDetail as {} || {}}
                    />
                </Box>
            )
        }
    </div>


});

export default Product;

type ProductProps = {
    // 产品_id
    id?: string;
    // 组件类型  预览模式(用于资源回收站浏览) | 可编辑模式
    componentType?: 'EDIT' | 'PREVIEW' | 'ADD';
    // 数据管理
    useProductMobx: ProductState;
    goBack: () => void;

}

function SkeletonViewComp(): JSX.Element {
    return (
        <Box className='skeleton'>
            <Grid container spacing={3}>
                <Grid item xs={12} md={12}>
                    <CardView
                        style={{ height: '100%' }}
                        contentRender={(
                            <Grid container rowSpacing={4}>
                                <Grid item xs={12}>
                                    <Skeleton variant='rounded' width={90} height={25} animation='wave' />
                                </Grid>
                                <Grid item xs={12}>
                                    <Skeleton variant='rounded' height={30} animation='wave' />
                                </Grid>
                                <Grid item xs={12}>
                                    <Skeleton variant='rounded' height={30} animation='wave' />
                                </Grid>
                                <Grid item xs={12}>
                                    <Skeleton variant='rounded' height={30} animation='wave' />
                                </Grid>
                                <Grid item xs={12}>
                                    <Skeleton variant='rounded' height={30} animation='wave' />
                                </Grid>
                                <Grid item xs={12}>
                                    <Skeleton variant='rounded' height={30} animation='wave' />
                                </Grid>
                            </Grid>
                        )}
                    />
                </Grid>
            </Grid>
        </Box>
    )
}